import React from 'react';
import { Mail, Building } from 'lucide-react';

function About() {
  return (
    <div className="page-content center-content">
      <h1 className="title">
        About Us
      </h1>
      <p className="subtitle" style={{ maxWidth: '600px', marginBottom: '48px' }}>
        We are a passionate team of engineers and designers building the next generation of decentralized and AI-powered applications. 
      </p>
      
      <div style={{ 
        background: 'rgba(255, 255, 255, 0.02)', 
        border: '1px solid rgba(255, 255, 255, 0.05)',
        padding: '40px',
        borderRadius: '24px',
        textAlign: 'left',
        width: '100%',
        maxWidth: '500px'
      }}>
        <h3 style={{ fontSize: '24px', margin: '0 0 24px 0', color: '#f8f9fa' }}>Retrorocket Labs Oy</h3>
        
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', color: '#a3a4a9', fontSize: '18px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <Building size={24} style={{ color: '#ff6b4a' }} />
            <div>
              <span style={{ color: '#f8f9fa', display: 'block', fontSize: '14px', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px' }}>Business ID</span> 
              FI35045639
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <Mail size={24} style={{ color: '#ff6b4a' }} />
            <div>
              <span style={{ color: '#f8f9fa', display: 'block', fontSize: '14px', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px' }}>Email</span> 
              <a href="mailto:hello@retrorocket.ai" style={{ color: '#a3a4a9', textDecoration: 'none' }}>hello@retrorocket.ai</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;